/**
 * Cliente de PostHog para analytics de producto.
 *
 * Configurado con `persistence: "localStorage"` para evitar cookies persistentes
 * (mejor para privacidad y para no necesitar banner de consentimiento).
 *
 * `autocapture: false` para tener control explícito de qué eventos enviamos —
 * ahorro de events del free tier + cumple con principio de minimización de datos.
 */
import posthog from "posthog-js";

const POSTHOG_KEY  = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";

let initialized = false;

export function initPostHog() {
  if (initialized) return;
  if (!POSTHOG_KEY) {
    console.warn("[posthog] VITE_POSTHOG_KEY no configurada — analytics deshabilitados.");
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host:                  POSTHOG_HOST,
    persistence:               "localStorage",
    autocapture:               false,
    capture_pageview:          false, // capturamos manualmente cuando importa
    disable_session_recording: true,
    // Web Vitals: captura métricas de performance (LCP, FID, CLS) sin datos del usuario.
    // Útil para detectar si la PWA va lenta en algún device. Bajo volumen de eventos.
    capture_performance: true,
    loaded: (ph) => {
      if (import.meta.env.DEV) ph.opt_out_capturing(); // no enviar en dev
    },
  });
  initialized = true;
}

/**
 * Identifica al usuario en PostHog tras login. Stitchea automáticamente los
 * eventos anónimos previos al login con el user identificado.
 */
export function identifyUser(userId, props = {}) {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, props);
}

/**
 * Limpia el identify al hacer logout. Eventos posteriores quedan anónimos.
 */
export function resetUser() {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}

/**
 * Captura un evento custom con propiedades opcionales.
 */
export function track(event, props = {}) {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, props);
}

export default posthog;
